<template>
  <component :is="tag" class="content-r">
    <slot />
  </component>
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: "div"
    }
  }
};
</script>

<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.content-r {
  padding-right: 15px;
  padding-left: 15px;
  width: 100%;
}
@media (min-width: variables.$sm) {
  .content-r {
    width: variables.$sm-width;
    margin-right: auto;
    margin-left: auto;
  }
}
@media (min-width: variables.$md) {
  .content-r {
    padding-left: variables.$spacing-l / 2;
    width: variables.$md-width / 2;
    margin-left: 0;
  }
}
@media (min-width: variables.$lg) {
  .content-r {
    width: variables.$lg-width / 2;
  }
}
@media (min-width: variables.$xl) {
  .content-r {
    width: variables.$xl-width / 2;
  }
}
</style>
